import React from "react";
import { Icon } from "rhombus-react";

export function renderLabel(social, iconName){
	return(
		<span className="tab-label">
			<Icon name={iconName} className="social-icon" />
			{social}
		</span>
	);
}

export const GENERIC_PREVIEW_TAB = {
	label: "Generic Preview",
	value: "generic",
	renderLabel(){
		return renderLabel("Generic Preview", "far fa-eye");
	},
};

export const FACEBOOK_TAB = {
	label:"Facebook",
	value:"facebook",
	renderLabel(){
		return renderLabel("Facebook", "fab fa-facebook");
	},
};
export const INSTAGRAM_TAB = {
	label:"Instagram",
	value:"instagram",
	renderLabel(){
		return renderLabel("Instagram", "fab fa-instagram");
	},
};
export const FB_MESSENGER_TAB = {
	label:"Messenger",
	value:"messenger",
	renderLabel(){
		return renderLabel("Messenger", "fab fa-facebook-messenger");
	},
};
export const YOUTUBE_TAB = {
	label:"Youtube",
	value:"youtube",
	renderLabel(){
		return renderLabel("Youtube", "fab fa-youtube");
	},
};

export const FEEDS_TAB = {
	label: "Feeds",
	value: "feeds",
};

export const STORIES_TAB = {
	label: "Stories",
	value: "stories",
};

export const REELS_TAB = {
	label: "Reels",
	value: "reels",
};

export const EXPLORE_HOME_TAB = {
	label: "Explore Home",
	value: "explore_home",
};

export const TABS = [
	GENERIC_PREVIEW_TAB,
	FACEBOOK_TAB,
	INSTAGRAM_TAB,
	FB_MESSENGER_TAB,
	/* YOUTUBE_TAB */
];

export const TABS_MO = [
	FACEBOOK_TAB,
	INSTAGRAM_TAB
];


export const PLACEMENT_TABS = [
	FEEDS_TAB,
	STORIES_TAB,
	REELS_TAB,
	EXPLORE_HOME_TAB
];

export const REDDIT_CARD_TAB = {
	label: "Card",
	value: "card",
};

export const REDDIT_COMPACT_TAB = {
	label: "Compact",
	value: "compact",
};

export const REDDIT_CONVERSATION_TAB = {
	label: "Conversation",
	value: "conversation",
};

export const REDDIT_PLACEMENT_TABS = [
	REDDIT_CARD_TAB,
	REDDIT_COMPACT_TAB,
	REDDIT_CONVERSATION_TAB,
];
